import { Store } from '../../../../../../../../../common/store/base/Store';
import { IMainLayoutDomainStore } from '../../../../../../../../../view/layout/main/store/domain/IMainLayoutDomainStore';
import { SettingUi } from './SettingUi';

export class SettingDomain extends Store {
  constructor(public layoutDomain: IMainLayoutDomainStore, public ui = new SettingUi()) {
    super();
  }
}
